export const saveSessionUserData = (userData: any) => {
  localStorage.setItem('user', JSON.stringify(userData))
}

export const saveSessionToken = ({ token }: { token: string }) => {
  localStorage.setItem('token', token)
}

export const removeSessionData = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('token')
  localStorage.removeItem('tokenExpiry')
}

// Password reset spans three pages, so keep the email and the verified-OTP token
// in sessionStorage to survive a refresh.
// Starting a new reset drops any token verified in an earlier attempt
export const saveResetEmail = (email: string) => {
  sessionStorage.setItem('resetEmail', email)
  sessionStorage.removeItem('resetToken')
}

export const getResetEmail = () => sessionStorage.getItem('resetEmail')

export const saveResetToken = (token: string) => {
  sessionStorage.setItem('resetToken', token)
}

export const getResetToken = () => sessionStorage.getItem('resetToken')

export const removeResetData = () => {
  sessionStorage.removeItem('resetEmail')
  sessionStorage.removeItem('resetToken')
}

export const getUserData = () => {
  let userProfile

  try {
    userProfile = JSON.parse(localStorage.getItem('user') || '')
  } catch (e) {}
  return userProfile
}

export const getAuthToken = () => {
  return localStorage.getItem('token')
}
